import React from 'react'
import './Why_Choose_US.css'

const Why_Choose_US = () => {

    const data = [
        {
            image: "/assets/Image/aboutus/why_choose_us/img1.png",
            title: "On Time Service",
            descn: "Get your loan approved and funded on time, every time."
        },
        {
            image: "/assets/Image/aboutus/why_choose_us/img2.png",
            title: "A Team of Professionals",
            descn: "Our team of experienced professionals is here to guide you through your loan process."
        },
        {
            image: "/assets/Image/aboutus/why_choose_us/img3.png",
            title: "Fast Loan Approval",
            descn: "Get your loan approved quickly and efficiently with our streamlined process."
        },
    ]

    return (
        <section className='Why_Choose_US'>
            <div className='container-fluid p-0'>
                <div className='content_holder'>
                    <div className='row me-0 ms-0'>
                        <div className='col-sm-6 col-12'>

                            <div className='left_side'>
                                <div className='img_holder'>
                                    <img src='assets/Image/aboutus/why_choose_us/why2.png' className='why_image' />
                                </div>

                                <div className='overlay_colour'></div>
                            </div>


                        </div>

                        <div className='col-sm-6 col-12'>
                            <div className='text_data_holder'>
                                <p className='why_heading_text'>Why</p>
                                <p className='heading_text'>Choose us?</p>

                                <div className='feature_div'>

                                    {data?.map((item) => {
                                        return (
                                            <div className='feature_text_div'>
                                                <div className='img_div'>
                                                    <img src={item?.image} className='icon_img' />
                                                </div>

                                                <div className='right_side_div'>
                                                    <p className='title_text'>{item?.title}</p>
                                                    <p className='descn_text'>{item?.descn}</p>
                                                </div>
                                            </div>
                                        )
                                    })}

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}

export default Why_Choose_US
